module.exports = "/_next/static/images/3ca1c74c9a1274eeee7aba30052c2976-rec-group-white.svg";